import { NgModule } from '@angular/core';
import { Routes, PreloadAllModules, RouterModule } from '@angular/router';
import { AuthGuard } from './global_services/auth.guard';
import { WelcomeComponent} from './welcome/welcome.component';

const routes: Routes = [
  {
    path: '', 
    component: WelcomeComponent,
    children: [
      { path: 'collection_process', canActivate: [AuthGuard], loadChildren: () => import('../app/collection_process/collection_process.module').then(m => m.CollectionProcessModule), data: { animation: 'quizzTake' }, runGuardsAndResolvers: 'always' },      
      { path: 'login', loadChildren: () => import('../app/login/login.module').then(m => m.LoginModule) },
      { path: 'start-screen', loadChildren: () => import('../app/start-screen/start-screen.module').then(m => m.StartScreenModule) },
      { path: 'register_examinee', loadChildren: () => import('../app/register_examinee/register_examinee.module').then(m => m.RegisterExamineeModule) },
      { path: 'users', loadChildren: () => import('../app/users/users.module').then(m => m.UsersModule) },
      { path: 'store', loadChildren: () => import('../app/landing_page/landing_page.module').then(m => m.LandingPageModule) },
      { path: '', redirectTo: 'start-screen', pathMatch: 'full' },
      // { path: '**', redirectTo: 'collection_process' },
    ] ,    
  },
  {
    path: ':client', 
    component: WelcomeComponent,
    children: [
      { path: 'collection_process', canActivate: [AuthGuard], loadChildren: () => import('../app/collection_process/collection_process.module').then(m => m.CollectionProcessModule), data: { animation: 'quizzTake' }, runGuardsAndResolvers: 'always' },      
      { path: 'login', loadChildren: () => import('../app/login/login.module').then(m => m.LoginModule) },
      { path: 'start-screen', loadChildren: () => import('../app/start-screen/start-screen.module').then(m => m.StartScreenModule) },
      { path: 'register_examinee', loadChildren: () => import('../app/register_examinee/register_examinee.module').then(m => m.RegisterExamineeModule) },
      { path: 'users', loadChildren: () => import('../app/users/users.module').then(m => m.UsersModule) },
      { path: 'store', loadChildren: () => import('../app/landing_page/landing_page.module').then(m => m.LandingPageModule) },
      { path: '', redirectTo: 'start-screen', pathMatch: 'full' },
      // { path: '**', redirectTo: 'collection_process' },
    ] ,    
  },
  { path:'password-reset/:client/:username/:token', loadChildren: () => import('../app/login/password-reset/password-reset.module').then(m => m.PasswordResetModule) },

  { path: '**', component: WelcomeComponent },
  
  // { path: '', redirectTo: '/start-screen', pathMatch: 'full' },
  // { path: '**', redirectTo: '/start-screen', pathMatch: 'full' },
  // { path: '**', component: PageNotFoundComponent }
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
